module.exports = __webpack_public_path__ + "static/img/WESTERN-BULLDOGS.926f376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WESTERN-BULLDOGS.svg
// module id = OVvc
// module chunks = 0